import { toast } from 'react-toastify';
import apiClient from '../utils/apiCliente';

const extractApiErrorMessage = (errorData) => {
	if (!errorData) return null;
	if (typeof errorData === 'string') {
		try {
			const parsed = JSON.parse(errorData);
			return parsed?.error || parsed?.message || errorData;
		} catch (_e) {
			return errorData;
		}
	}

	return errorData.error || errorData.message || null;
};

export const finalizarPedido = async (
	pedidoId,
	metodoPagoId,
	paymentId,
	direccionId,
	fechaEnvio,
	deliveryMethod,
	notas,
	notasCocinera,
	cupon,
	token,
	sucursalId = null,
) => {
	const body = {
		pedido_id: pedidoId,
		metodo_pago_id: metodoPagoId,
		payment_id: paymentId,
		direccion_id: direccionId,
		fecha_envio: fechaEnvio,
		delivery_method: deliveryMethod,
		cupon: cupon,
		notas: notas,
		notas_cocinera: notasCocinera,
		sucursal_id: sucursalId,
	};

	try {
		const response = await apiClient.put('/pedidos/finalizarPedido', body, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				toast.info('Su sesión ha expirado. Por favor, inicie sesión nuevamente.', {
					onClose: () => {
						window.location.href = '/login';
					},
				});
			} else {
				const errorData = error.response.data;
				const backendMessage = extractApiErrorMessage(errorData);
				throw new Error(backendMessage || 'Se produjo un error desconocido.');
			}
		} else if (error.request) {
			throw new Error('No se pudo establecer conexión con el servidor.');
		} else {
			throw new Error('Error al realizar la solicitud.');
		}
	}
};
